"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var Overlay_1 = require("../Overlay");
var DialogBase_1 = require("./DialogBase");
/**
 * @internal
 */
var Dialog = /** @class */ (function (_super) {
    tslib_1.__extends(Dialog, _super);
    function Dialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Dialog.prototype.render = function () {
        var _a = this.props, containerClassName = _a.containerClassName, onClick = _a.onClick, onMouseUp = _a.onMouseUp, onMouseOver = _a.onMouseOver, dialogProps = tslib_1.__rest(_a, ["containerClassName", "onClick", "onMouseUp", "onMouseOver"]);
        return (react_1.default.createElement(Overlay_1.Overlay, { alignPoints: [
                {
                    align: "cc cc",
                },
            ], isModal: true, positionType: "fixed", containerClassName: containerClassName, onMouseUp: onMouseUp, onMouseOver: onMouseOver, onClick: onClick },
            react_1.default.createElement(DialogBase_1.DialogBase, tslib_1.__assign({}, dialogProps))));
    };
    return Dialog;
}(react_1.Component));
exports.Dialog = Dialog;
//# sourceMappingURL=Dialog.js.map